module.exports = __webpack_public_path__ + "img/preloaderspin.e5e9172f.gif";